const ONE_SECOND_MS = 1000;
export function secondsInMs(seconds) {
    return seconds * ONE_SECOND_MS;
}
//# sourceMappingURL=time.js.map